<div class="custom-modal modal-extrato-estoque">
  <div class="header">
    <h1 mat-dialog-title>
      Extrato de Estoque
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div *ngIf="isLoading" class="d-flex justify-content-center">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
  </div>
  <div mat-dialog-content class="content" [hidden]="isLoading">
    <div class="d-flex flex-row justify-content-between">
      <div><strong>Cliente: </strong>{{ extratoDetalhes?.cliente }}&nbsp;</div>
      <div><strong>Produto: </strong>{{ produto?.nome }}&nbsp;</div>
      <div><strong>Filial: </strong>{{ extratoDetalhes?.filial }}&nbsp;</div>
      <div><strong>Data: </strong>{{ dataExtrato | date: 'dd/MM/yyyy' }}&nbsp;</div>
    </div>
    <mat-divider></mat-divider>
    <mat-button-toggle-group #tipo="matButtonToggleGroup" value="All">
      <mat-button-toggle value="2"
        (click)="selecionarExtratoEstoqueDetalhe(tipo.value, false)"
        checked>
        Entrada
      </mat-button-toggle>
      <mat-button-toggle value="3, 6"
        (click)="selecionarExtratoEstoqueDetalhe(tipo.value, false)">
        Saída
      </mat-button-toggle>
      <mat-button-toggle value=""
        (click)="selecionarExtratoEstoqueDetalhe(tipo.value, true)">
        Devoluções
      </mat-button-toggle>
    </mat-button-toggle-group>
    <div *ngIf="isTableLoading" class="d-flex justify-content-center">
      <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <div [hidden]="isTableLoading || extratos?.data?.length < 1">
      <div>
        <table mat-table [dataSource]="extratos">
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Situação </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.status }} </td>
            <td mat-footer-cell *matFooterCellDef><Strong>Total</Strong></td>
          </ng-container>

          <ng-container matColumnDef="data">
            <th mat-header-cell *matHeaderCellDef> Data </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.data | date: 'dd/MM/yyyy'}} </td>
            <td mat-footer-cell *matFooterCellDef><strong> {{ totalExtrato() }} </strong></td>
          </ng-container>

          <ng-container matColumnDef="modelo">
            <th mat-header-cell *matHeaderCellDef> Modelo </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.modelo }} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="sequencia">
            <th mat-header-cell *matHeaderCellDef> Nº Seq. </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.sequencia }} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="codigoBarra">
            <th mat-header-cell *matHeaderCellDef> Cód. de Barras </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.codigoBarra }} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef> Usuário </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.usuario }} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <ng-container matColumnDef="origem">
            <th mat-header-cell *matHeaderCellDef> Origem </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.origem }} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <ng-container matColumnDef="destino">
            <th mat-header-cell *matHeaderCellDef> Destino </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.destino }} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <ng-container matColumnDef="usuarioDev">
            <th mat-header-cell *matHeaderCellDef> Usuário </th>
            <td mat-cell *matCellDef="let extratos"> {{ extratos?.usuario }} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
      <app-paginacao [pageIndex]="paging?.index"
        [pageSize]="paging?.size"
        [length]="paging?.length"
        (page)="onPageChange($event)"
        [pageSizeOptions]="[5]"
      ></app-paginacao>
    </div>
    <div *ngIf="!isTableLoading && extratos?.data?.length == 0" class="sem-registros" style="height: 100px;">
      Sem registros para exibição!
    </div>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close color="primary">OK</button>
  </div>
</div>